import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import HeroSection from '../components/HeroSection';
import FeaturesSection from '../components/FeaturesSection';
import USAMap from '../components/USAMap';
import bannerEjemplo from '../assets/images/banners/ejemplo.webp';

const HomePage = () => {
  const formatTime = (date) => {
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
  };

  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 30_000);
    return () => clearInterval(id);
  }, []);

  const timeZones = useMemo(() => {
    const base = now;
    const options = {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    };

    const safeFormat = (timeZone) => {
      try {
        return new Intl.DateTimeFormat('en-US', { ...options, timeZone }).format(base);
      } catch (_) {
        return formatTime(base);
      }
    };

    return [
      { label: 'PST', value: safeFormat('America/Los_Angeles') },
      { label: 'MST', value: safeFormat('America/Denver') },
      { label: 'CST', value: safeFormat('America/Chicago') },
      { label: 'EST', value: safeFormat('America/New_York') }
    ];
  }, [now]);

  return (
    <div className="home-page">
      <HeroSection />

      <section className="home-impact-media">
        <div className="container">
          <div className="home-media-grid">
            <div className="home-media-slider" aria-label="Galería de GesOps">
              <div className="home-media-slide" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1400&q=60)' }} />
              <div className="home-media-slide" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1507679799987-c73779587ccf?auto=format&fit=crop&w=1400&q=60)' }} />
              <div className="home-media-slide" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1449824913935-59a10b8d2000?auto=format&fit=crop&w=1400&q=60)' }} />
              <div className="home-media-slide" style={{ backgroundImage: `url(${bannerEjemplo})` }} />
            </div>

            <div className="home-impact-widgets">
              <div className="timezones-card">
                <h3 className="widget-title">Husos horarios en EE. UU.</h3>
                <div className="timezones-grid">
                  {timeZones.map((tz) => (
                    <div key={tz.label} className="timezone-item">
                      <span className="timezone-label">{tz.label}</span>
                      <span className="timezone-time">{tz.value}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="mini-map-card">
                <h3 className="widget-title">Cobertura nacional</h3>
                <p className="widget-subtitle">51 estados + Puerto Rico con servicios disponibles</p>
                <div className="mini-map-visual" aria-hidden="true">
                  <USAMap interactive={false} />
                </div>
                <div className="mini-map-cta">
                  <Link to="/explora" className="btn btn-primary">
                    Explorar en el mapa
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="home-metrics">
        <div className="container">
          <div className="metrics-grid">
            <div className="metric-card">
              <span className="metric-number">+100</span>
              <span className="metric-label">Profesionales verificados</span>
            </div>
            <div className="metric-card">
              <span className="metric-number">51</span>
              <span className="metric-label">Estados + Puerto Rico</span>
            </div>
            <div className="metric-card">
              <span className="metric-number">100%</span>
              <span className="metric-label">Contacto directo</span>
            </div>
            <div className="metric-card">
              <span className="metric-number">Latinos</span>
              <span className="metric-label">Comunidad en crecimiento</span>
            </div>
          </div>

          <div className="home-primary-cta">
            <Link to="/explora" className="btn btn-primary">Buscar Servicios</Link>
            <Link to="/profesionales/unete" className="btn btn-secondary">Soy Profesional</Link>
          </div>
        </div>
      </section>

      <FeaturesSection />

      <section className="home-important-notice">
        <div className="container">
          <div className="disclaimer-box">
            <div className="disclaimer-content">
              <p>
                <strong>Aviso importante:</strong> GesOps es un directorio que conecta personas con empresas y profesionales verificados.
                No compartimos honorarios ni ofrecemos asesoría legal directa.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
